module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAUFJREFUWAntlTtOAzEQhmcWQcExsj4B3CUFJSLhcQIi0ZJdUSJFIpwAJeeg5AYgCujoaSD5MYlswEKLH1NQzDaz9u4/++mztSbSSw2oATWgBtTAvzCAth5gXD+jqS8AsBSUSCM05oSwnHgo5ms6vT9iZvi5zJsqM+djX3B8u560FRhSY6YSJosAv8HNaGvjYAVY8SUxnxFhQK25KoXMBvwBZ3b26G3x7rTy6OF8BSlgMgswhOP+fOHgXPWQnyYLljsZMAZOEjIJMAVOCjIaEG3veP0r4RnZPffbsjqosIbLHT7vGkcD0pJHRHyTCuc+7iEZ+5jubrp5sWqbbnc1syeIwbgHtKbf+d4ffcJstEE+vHsNwznj1D7RgDkwEhkFLLWoBtVgqYHSvNweZLzYk+aJUD2WQmleDagBNaAG1ICcgQ+nTZezKNVa8AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/official/home_sign_arrow_upward.png
// module id = q6uv
// module chunks = 0